/* import __COLOCATED_TEMPLATE__ from './due-date-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellDueDateCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellDueDateCellComponent = templateOnlyComponent<CellDueDateCellSignature>();

export default CellDueDateCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::DueDateCell': typeof CellDueDateCellComponent;
    'cell/due-date-cell': typeof CellDueDateCellComponent;
  }
}
